import * as cn from "classnames";
import * as React from "react";
import ImageLoader from "react-load-image";
import DotLoader from "../dotLoader";
import * as styles from "./styles.css";
import { analytics, DataLayerInitializationData } from "@lonelyplanet/lp-analytics";
var ImageError = function (_a) {
    var _b = _a.children, children = _b === void 0 ? "Image unavailable" : _b;
    return (React.createElement("div", { className: cn(styles.fallback, styles.error) },
        React.createElement("p", null, children)));
};
var ImageLoading = function (props) { return (React.createElement("div", { className: cn(styles.fallback) },
    React.createElement(DotLoader, null))); };
var Picture = function (_a) {
    var sources = _a.sources, src = _a.src, srcSet = _a.srcSet, alt = _a.alt, className = _a.className;
    var _b;
    return (React.createElement(React.Fragment, null,
        React.createElement(DataLayerInitializationData, { data: (_b = {}, _b[analytics.hasPhoto] = true, _b) }),
        React.createElement(ImageLoader, { src: src },
            React.createElement("picture", null,
                sources.map(function (source) { return (React.createElement("source", { key: src + " " + source.media, media: source.media, srcSet: source.srcSet })); }),
                React.createElement("img", { className: cn(className), srcSet: srcSet, src: src, alt: alt })),
            React.createElement(ImageError, null),
            React.createElement(ImageLoading, null))));
};
export default Picture;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/picture/index.tsx
// module id = XxOm
// module chunks = 2